export default function replaceKey(object, oldKey, newKey) {
  if (!(newKey in object) && (oldKey in object)) {
    object[newKey] = object[oldKey]
    delete object[oldKey]
  }
}
